import api from "../../../services/api";

export interface AddEventPayload {
  title: string;
  source: string;
  start_at: string;
  end_at: string;
  description?: string;
}

export interface AddEventResponse {

  title: string;
  source: string;
  start_at: string;
  end_at: string;
  description?: string;
}

export async function addEventService(payload: AddEventPayload): Promise<AddEventResponse> {
  const res = await api.post<AddEventResponse>("/api/key_points", payload);
  return res.data;
}